import { render, staticRenderFns } from "./LaundrySeksiChecklist.vue?vue&type=template&id=71bd0208&scoped=true&"
import script from "./LaundrySeksiChecklist.vue?vue&type=script&lang=ts&"
export * from "./LaundrySeksiChecklist.vue?vue&type=script&lang=ts&"
import style0 from "./LaundrySeksiChecklist.vue?vue&type=style&index=0&id=71bd0208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bd0208",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VChip,VFileInput,VIcon,VSimpleTable,VTextField,VTextarea})
